import { Chip } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { SortDirection } from "../../interfaces";
import { City } from "../../interfaces/City";
import { beachSelectors, citySelectors } from "../../redux";
import { loadAllCity } from "../../redux/city/sagaActions";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
  actionButtons: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  chips: {
    marginRight: theme.spacing(1),
  },
}));

interface Column {
  id: "name" | "province" | "region" | "istat" | "beaches";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: Column[] = [
  { id: "name", label: "Nome", minWidth: 100 },
  {
    id: "province",
    label: "Provincia",
    minWidth: 110,
    align: "right",
  },
  {
    id: "region",
    label: "Regione",
    minWidth: 110,
    align: "right",
  },
  {
    id: "istat",
    label: "Istat",
    minWidth: 110,
    align: "right",
  },

  {
    id: "beaches",
    label: "Spiagge",
    minWidth: 60,
    align: "right",
  },
];

interface Data extends Omit<City, "id"> {}

interface TableCityProps {
  onEditCity: (holder: City | undefined) => void;
  onDeleteCity: (id: string) => void;
}

const TableCity: React.FC<TableCityProps> = ({ onDeleteCity, onEditCity }) => {
  const cities = useSelector(citySelectors.getAllCities);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const maxPage = Number(cities.data?.totalCount);
  const getCityById = useSelector(citySelectors.getCityById);
  const getBeachById = useSelector(beachSelectors.getBeachById);
  const history = useHistory();

  const deleteCity = (id?: string) => {
    if (id) onDeleteCity(id);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    if (newPage > page) {
      dispatch(
        loadAllCity({
          start_after: cities.data?.results[cities.data?.results.length - 1].id,
          sort_by: [{ field: "id", order: SortDirection.ASC }],
        })
      );
    } else {
      dispatch(
        loadAllCity({
          end_before: cities.data?.results[cities.data?.results.length - 1].id,
          sort_by: [{ field: "id", order: SortDirection.ASC }],
        })
      );
    }
    setPage(0);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSelectCity = (id: string) => {
    onEditCity(getCityById(id));
  };

  if (!cities.data || cities.data?.results.length === 0) return null;

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
              <TableCell align="right">Modifica</TableCell>
              <TableCell align="right">Elimina</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cities.data?.results.map((row) => {
              return row ? (
                <TableRow hover role="checkbox" tabIndex={-1} key={row?.id}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.id === "beaches" &&
                        row?.beaches !== undefined &&
                        row?.beaches.length > 0
                          ? row.beaches.map((b) => (
                              <Chip
                                onClick={() => history.push(`/beach/edit/${b}`)}
                                className={classes.chips}
                                label={getBeachById(b)?.name}
                                variant="outlined"
                              />
                            ))
                          : value}
                      </TableCell>
                    );
                  })}

                  <TableCell align="right">
                    <Tooltip title="Modifica">
                      <IconButton
                        aria-label="edit"
                        onClick={() => row.id && handleSelectCity(row.id)}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="right">
                    <Tooltip title="Elimina Riga">
                      <IconButton
                        aria-label="delete"
                        onClick={() => deleteCity(row?.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ) : null;
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={maxPage}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage="N. elementi"
      />
    </Paper>
  );
};

export default TableCity;
